import React, { useEffect, useState } from 'react'
import CONSTANT from '../../Constants'
import './MapContainer.scss'
import '../SummaryBlock/DealerSearch/DealerSearch.scss'
import fetchApiData from '../../apiHandlers/fetchApiData'
import { useSelector, useDispatch } from 'react-redux'
import MyMap from './MyMap/MyMap'
import DealersList from './DealersList/DealersList'
import { dealersPerPageContext } from './context'
import DealersFilter from './DealersFilter'
import DealerSearch from '../SummaryBlock/DealerSearch/DealerSearch'
import { isMobile } from '../../helpers/helpers'
import StickyButton from '../Forms/StickyButton'
import CONSTANTS from '../../Constants'
import { setDealerDetails, setSelectedForfaitsToStore, setSelectedMandatoryAdditionalForfaitsToStore } from '../../redux-files/actions/action'
import PopIn from '../PopIn/PopIn'
import { pushToGTMTracker, pushEventToGTM } from '../../helpers/trackerManager'
import useBodyClass from '../../custom-Hooks/useBodyClass';
// import { setAddressSearch } from '../../redux-files/actions/action'
const MapContainer = ({ closeDealersMap, addressSearch }) => {

    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo) // to filter dealers according to the vehicle PC or LCV 
    const selectedDelaer = useSelector(state => state.ndel_store.dealer)
    const [showFullMap, setShowFullMap] = useState(true)
    const [dealersList, setDealersList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [searchedAddress, setSearchedAddress] = useState(addressSearch)
    const [dealersListPerPage, setDealersListPerPage] = useState([])
    const [dealersListFiltred, setDealersListFiltred] = useState([])
    const [numberOfDealersToShow, setNumberOfDealersToShow] = useState(10)
    const [showFilterPopin, setShowFilterPopin] = useState(false)
    const [isFiltersActive, setIsFiltersActive] = useState(false)
    // const [locationOnMap, setLocationOnMap] = useState({
    //     address: searchedAddress.address,
    //     lat: searchedAddress.lat || 47,
    //     lng: searchedAddress.lng || 2
    // })
    const dispatch = useDispatch()
    const google = window.google;
    // useEffect call loadDealers one time
    useEffect(() => {
        console.log('useEffect run LoadDealers ...')
        let isMounted = true;
        loadDealers(isMounted)
        getPremiumServicePCLCVActivation()
        return () => {
            isMounted = false

        };
        // empty dependency array means this effect will only run once (like componentDidMount in classes)
    }, []);
    useEffect(() => {
        if (selectedDelaer.editDealer || (selectedDelaer.iD === 0 && searchedAddress.address.length > 0)) {
            pushToGTMTracker('dealer-list', window.siteConfig.quotingPrestations.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))
        } else if (selectedDelaer.iD === 0 && searchedAddress.address.length <= 0) {
            pushToGTMTracker('dealer-locator', window.siteConfig.quotingPrestations.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))
        }
    }, [searchedAddress.address.length > 0])

    const getPremiumServicePCLCVActivation = () => {
        const PREMIUMSERVICES = new fetchApiData();
        PREMIUMSERVICES.getPremiumServices()
            .then(
                res => {
                    setIsFiltersActive(res.d.some(item =>
                        (item.codeIntern === 'PC' || item.codeIntern === 'LCV') && item.displayDL))
                }
            )
            .catch(Error => {
                console.error('Error: ', Error);
            });
    }

    // function change the latitude and longitude on the MAP according to the address in serche bar 
    const setLatLangAccordingToCitySearched = () => {
        let geocoder = new google.maps.Geocoder();
        return new Promise((resolve, reject) => {
            geocoder.geocode({
                'address': searchedAddress.address,
                componentRestrictions: {
                    country: window.siteConfig.currentCountry
                }
            }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        resolve(results[0].formatted_address);
                    } else {
                        console.log('No results found');
                    }
                } else {
                    console.error(new Error('Geocoder failed due to: ' + status));
                }
            })
        });

    }
    // fucntion calculate the distance between the address searched and the dealers List to sort dealers by distance and show the nearest dealers first 
    const getDistanceBetweenPlaces = (dealersData) => {
        let place = { lat: searchedAddress.lat, lng: searchedAddress.lng };
        let dealers = Object.values(dealersData).map(dealer => {
            dealer.IsHover = false;
            const currentAdress = new google.maps.LatLng(place.lat, place.lng);
            const dealerLocation = new google.maps.LatLng(dealer.Latitude, dealer.Longitude);
            dealer.Distance = (google.maps.geometry.spherical.computeDistanceBetween(currentAdress, dealerLocation) / 1000).toFixed(2);
            return dealer;
        });
        return dealers.sort((a, b) => {
            return a.Distance - b.Distance;
        });
    }

    // useEffect show 10 dealers in a page according to the address searched and sort them by distance and focus on the new location in the map
    useEffect(() => {
        console.log('useEffect run after adress changed...')
        let isMounted = true;
        let listDealerPerPage = []
        if (isMounted) {
            !isMobile() && setSearchedAddress(addressSearch)
            if (searchedAddress.address.length > 0) {
                setShowFullMap(false)
                setLatLangAccordingToCitySearched().then(() => {
                    listDealerPerPage = getDistanceBetweenPlaces(dealersList).sort((a, b) => {
                        return a.Distance - b.Distance;
                    }).slice(0, numberOfDealersToShow)
                    setDealersListPerPage(listDealerPerPage)
                })
            }

        }

        return () => {
            isMounted = false
        };
        // empty dependency array means this effect will only run once (like componentDidMount in classes)
    }, [addressSearch, searchedAddress]);

    //  API that call the webMethode GetListDealer 
    const loadDealers = (isMounted) => {
        const DEALERS_API = new fetchApiData();
        setIsLoading(true)
        DEALERS_API.getListDealers()
            .then(
                data => {
                    if (isMounted) {
                        let dealersSorted = getDistanceBetweenPlaces(data.d).sort((a, b) => {
                            return a.Distance - b.Distance;
                        })
                        let dealers = [...dealersSorted]
                        for (let i = 0; i < Object.keys(dealers).length; i++) {
                            dealers[i] = {
                                ...dealers[i],
                                isClicked: false
                            };
                            if (dealers[i].DealerId === selectedDelaer.iD) {
                                dealers[i] = {
                                    ...dealers[i],
                                    isClicked: true
                                };
                            }

                        }
                        setDealersList(dealers)
                        setDealersListFiltred(dealers)
                        setIsLoading(false)
                        if (searchedAddress.address.length > 0) setLatLangAccordingToCitySearched().then(() => {
                            setDealersListPerPage(dealers.slice(0, numberOfDealersToShow))
                        })
                    }

                })
            .catch(Error => {
                setIsLoading(false)
                console.log('Eror: ', Error);
            });
    }
    // function handl the click on show more dealers, it add 10 dealers on every click
    const handlShowMore = () => {
        setDealersListPerPage(dealersListFiltred.slice(0, numberOfDealersToShow + 10))
        setNumberOfDealersToShow(numberOfDealersToShow + 10)
    }
    // function handl the hover on the dealer block
    const MouseEnterDealerBlock = (id) => {
        console.log('mouse enter')
        let dealers = [...dealersListPerPage];
        for (let i = 0; i < Object.keys(dealers).length; i++) {

            if (dealers[i].DealerId === id) {
                dealers[i].IsHover = true;
            }
        }
        setDealersListPerPage(dealers)
    }
    // function handl the mouse leaving the dealer block
    const MouseLeaveDealerBlock = () => {
        let dealers = [...dealersListPerPage]
        for (let i = 0; i < Object.keys(dealers).length; i++) {
            dealers[i].IsHover = false;

        }
        setDealersListPerPage(dealers)
    }
    // function handl the click on dealer block
    const onDelaerClikced = (id) => {
        let dealers = showFullMap ? [...dealersList] : [...dealersListPerPage];
        for (let i = 0; i < Object.keys(dealers).length; i++) {

            if (dealers[i].DealerId === id) {
                dealers[i] = {
                    ...dealers[i],
                    isClicked: true
                };
            }
            else {
                dealers[i] = {
                    ...dealers[i],
                    isClicked: false
                };
            }
        }
        showFullMap ? setDealersList(dealers) : setDealersListPerPage(dealers)
    }
    const chooseDealerMobile = () => {

        const choosenDealer = dealersListPerPage.find(dealer => dealer.isClicked)
        // if(choosenDealer)
        if (choosenDealer.DealerId !== selectedDelaer.iD) {
            dispatch(setSelectedForfaitsToStore([]))
            dispatch(setSelectedMandatoryAdditionalForfaitsToStore([]))
        }
        dispatch(setDealerDetails({
            iD: choosenDealer.DealerId,
            geoID: choosenDealer.GeoId,
            name: choosenDealer.Name,
            adress: choosenDealer.Address,
            city: choosenDealer.City,
            zip: choosenDealer.ZipCode,
            LCV: choosenDealer.LCV,
            PC: choosenDealer.PC,
            listPremiumServices: choosenDealer.ListeIdSP,
            position: { lat: Number(choosenDealer.Latitude), lng: Number(choosenDealer.Longitude) },
            SelfReception: choosenDealer.SelfReception,
            editDealer: false
        }))
        pushEventToGTM({
            pageName: 'dealer locator',
            eventAction: 'Redirection::Internal::Services',
            eventLabel: choosenDealer.Name,
            eventCategory: 'Dealerlocator'
        })
    }
    const checkLCVPCChooseDealerMobile = () => {
        const choosenDealer = dealersListPerPage.find(dealer => dealer.isClicked)
        console.log(dealersListPerPage.some(dealer => dealer.isClicked))
        if ((vehicleInfo.LCV && choosenDealer.dealerLCV) || (vehicleInfo.PC && choosenDealer.dealerPC)) {
            chooseDealerMobile()
        } else {
            setShowFilterPopin(true)
        }
    }

    // (when checkBox clicked) function handl the filter on dealers with PC or LCV depending on the vehicle PC or LCV 
    const handlFilter = (e) => {
        let dealers = [...dealersList]
        if (e.target.checked) {
            const dealersFiltred = dealers.filter(dealer => vehicleInfo.PC ? dealer.PC : dealer.LCV)
            setDealersListFiltred(dealersFiltred)
            setDealersListPerPage(getDistanceBetweenPlaces(dealersFiltred).sort((a, b) => {
                return a.Distance - b.Distance;
            }).slice(0, numberOfDealersToShow))
        }
        else {

            setDealersListPerPage(getDistanceBetweenPlaces(dealersList).sort((a, b) => {
                return a.Distance - b.Distance;
            }).slice(0, numberOfDealersToShow))
            setDealersListFiltred(dealersList)
        }
    }
    // for mobile 
    const popInFilterContent = <div className='content-warning-filters'>
        <p className='warning-main' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_filter_alert_main) }}></p>
        <div className='warning-list'>
            <p className='warning-second' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_filter_alert_second) }}></p>
            <li className='warning-item'><i className='icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_warranty} </span> </li>
            <li className='warning-item'><i className='icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_maintenance}</span></li>
            <li className='warning-item'><i className='icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_recall_campain}</span></li>
            <li className='warning-item'><i className='icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_package}</span></li>
        </div>
    </div>
    useBodyClass(`page-map`)
    return (
        <dealersPerPageContext.Provider value={{ dealersListPerPage, MouseEnterDealerBlock, MouseLeaveDealerBlock, onDelaerClikced }}>
            <div className='map-container'>
                {showFullMap
                    ? <div className='full-map'>

                        {isMobile() && <div className='search-container'>
                            <DealerSearch onDealerSearch={(searchedAdress) => setSearchedAddress(searchedAdress)} onCloseDealersMap={closeDealersMap} />
                            {isFiltersActive && <DealersFilter onFilterClick={e => handlFilter(e)} />}
                        </div>
                        }

                        <MyMap
                            isFullMap={showFullMap}
                            dealersList={dealersList}
                            mapLocation={searchedAddress}
                        />
                    </div>
                    :
                    <>
                        <div className='content-block'>
                            <div className='dealers-half'>
                                <div className='block-title'>
                                    <h4 className='title'>{CONSTANT.LABELS.dealer_quote_list}</h4>
                                    {!isMobile() && isFiltersActive && <DealersFilter onFilterClick={handlFilter} />}
                                </div>
                                <DealersList
                                    isLoading={isLoading}
                                    showMoreDealers={handlShowMore}
                                    isPCLCVFiltersActived={isFiltersActive}
                                />
                            </div>
                            <div className='map-half'>
                                {isMobile() && <div className='search-container'>
                                    <DealerSearch onDealerSearch={(searchedAdress) => setSearchedAddress(searchedAdress)} onCloseDealersMap={closeDealersMap} />
                                    {isFiltersActive && <DealersFilter onFilterClick={handlFilter} />}
                                </div>
                                }
                                <MyMap
                                    isFullMap={showFullMap}
                                    dealersList={dealersListPerPage}
                                    mapZoom={12}
                                    mapLocation={searchedAddress}
                                    mapStylesProps={
                                        {
                                            height: "300px",
                                            maxWidth: "1280px",
                                            margin: "auto"
                                        }} />
                            </div>

                        </div>
                        {
                            //for Mobile 
                            isMobile() && showFilterPopin && <PopIn
                                title={CONSTANTS.LABELS.vehicule_filter_alert_title}
                                content={popInFilterContent}
                                primaryButtonLabel={CONSTANTS.LABELS.quote_alert_dealer}
                                secondaryButtonLabel={CONSTANTS.LABELS.common_v2_continue}
                                handlePrimaryButton={() => setShowFilterPopin(false)}
                                handleSecondaryButton={chooseDealerMobile}
                            />
                        }
                    </>
                }
            </div>
            {/*sticky button only for mobile*/}
            {isMobile() && !showFullMap && <StickyButton
                label={CONSTANTS.LABELS.dealer_quote_mobile2}
                isDisabled={!dealersListPerPage.some(dealer => dealer.isClicked)}
                handleClick={checkLCVPCChooseDealerMobile}
            />}
        </dealersPerPageContext.Provider>
    )
}

export default MapContainer;